import { render, staticRenderFns } from "./SettingsQualificationType.vue?vue&type=template&id=6b03773a&"
import script from "./SettingsQualificationType.vue?vue&type=script&lang=js&"
export * from "./SettingsQualificationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports